export function isPrintableCharacter(str) {
    return str.length === 1 && str.match(/\S/);
}

export const keyCode = Object.freeze({
    TAB: 9,
    RETURN: 13,
    ESC: 27,
    SPACE: 32,
    PAGEUP: 33,
    PAGEDOWN: 34,
    END: 35,
    HOME: 36,
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40,
});



// WEBPACK FOOTER //
// ./node_modules/wg5/src/modules/organisms/header/scripts/a11y-navigation/helpers.js